import { motion } from "framer-motion"
import type { ReactNode } from "react"

export default function PageTransition({ children }: { children: ReactNode }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } }}
      exit={{ opacity: 0, y: -12, transition: { duration: 0.25, ease: "easeIn" } }}
    >
      {children}
    </motion.div>
  )
}
